module.exports = __webpack_public_path__ + "img/HSIL.4a78864d.png";